import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useTranslation } from "react-i18next";
import { UpdateAlertModalData } from "../Store";

const AlertModal = () => {
  const { t } = useTranslation();
  const windowSizeCssClass = useSelector((state) => state.appMenu.screenSize);

  const alertHeader = useSelector((state) => state.generalModals.alertModalData.header);
  const alertText = useSelector((state) => state.generalModals.alertModalData.text);
  const isAlertShown = useSelector((state) => state.generalModals.alertModalData.isShown);

  const dispatch = useDispatch();

  const handleOnHide = () => {
    dispatch(UpdateAlertModalData({ isShown: false, header: "", text: "" }));
  };

  return (
    <Modal
      size={"lg"}
      dialogClassName={`custom-modal-dialog ${windowSizeCssClass}`}
      contentClassName={"custom-modal-content"}
      show={isAlertShown}
      onHide={() => handleOnHide()}
    >
      <div className={"bordered danger"}>
        <Modal.Header className={"border-0"} closeButton></Modal.Header>

        <Row>
          <Col className={"text-24 text-color-gray-dark fw-semibold text-center"}>{t(alertHeader)}</Col>
        </Row>

        {alertText && (
          <Row className={"justify-content-center pt-3  "}>
            <Col xs={12} sm={10} className={"text-18 text-color-gray-light fw-normal text-center"}>
              {t(alertText)}
            </Col>
          </Row>
        )}
      </div>
    </Modal>
  );
};
export default AlertModal;
